<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
      <div v-show="HtmbGl_add">
        <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">合同模板管理-修改</div>
        <el-button
          style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
          @click="Return">返回</el-button>
        <!-- 主体 -->
        <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
          <!-- 查询框 -->
          <div style="margin-left:3%">
            <div style="height:40px"></div>
            <div style="display:inline-block;margin-left:10px">
              <el-form-item label="员工合同模板名称" prop="template_name">
                <el-input v-model="ruleForm.template_name" style="margin-left:10px;width:200px" placeholder="请输入模板名称">
                </el-input>
              </el-form-item>
            </div>

            <div style="display:inline-block;margin-left:20px">
              <el-form-item label="员工合同模板名称" prop="dictionaries_name">
                <el-select v-model="ruleForm.dictionaries_name" style="margin-left:10px;width:160px" placeholder="请选择分类">
                  <el-option v-for="item in staffList" :key="item.id" :label="item.data" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div style="display:inline-block;margin-left:20px">
              <el-form-item label="员工合同模板名称" prop="template_date">
                <el-date-picker style="width:200px;margin-left:10px" v-model="ruleForm.template_date" type="date"
                  placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </div>

            <!-- 按钮 -->
            <div style="display:inline-block;margin-right:100px;float:right">
              <el-button type="goon" @click="cun()">保存</el-button>
            </div>
          </div>
          <template>
            <div class="edit_container">
              <!-- 新增时输入 -->
              <quill-editor style="margin-top:20px" v-model="ruleForm.template_content" ref="myQuillEditor"
                :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                @change="onEditorChange($event)">
              </quill-editor>
              <!-- 从数据库读取展示 -->
              <div v-html="str" class="ql-editor">
                {{str}}
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'; //调用编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import axios from 'axios';
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      riqi: '',
      input: '',
      content: '',
      HtmbGl_add: true,
      str: '',
      editorOption: {},
      staffList: [],
      rules: {
        template_name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
        ],
        dictionaries_name: [
          { required: true, message: '请选择类别！', trigger: 'blur' },
        ],
        template_date: [
          { required: true, message: '请选择日期！', trigger: 'blur' },
        ],
      },
      ruleForm: {
        id: '',
        template_name: '',
        dictionaries_name: '',
        template_date: '',
        template_content: '',
        template_url: '',
        template_state: '',
        reviewer_name: '',
        reviewer_date: '',
        reject_reason: '',
        dictionaries_name: '',
        start_date: '',
        end_date: '',
      },
      //条件
      condition: {
        dictionaries_name: '',
      },
    };
  },
  mounted() {
    let content = ''; // 请求后台返回的内容字符串
    this.str = this.escapeStringHTML(content);
  },
  methods: {
    Return() {
      this.$parent.Return();
      this.$parent.trash();
      this.$parent.Find();
    },
    cun() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
      this.content;
      // this.content = this.content.replace('张', '李');
      // console.log(this.content);
      axios({
        url: this.$globals.http + '/template/UpdateTemplate',
        method: 'post',
        data: {
          id: this.ruleForm.id,
          template_name: this.ruleForm.template_name,
          dictionaries_name: this.ruleForm.dictionaries_name,
          template_content: this.ruleForm.template_content,
          template_date: this.template_date,
        },
      })
        .then((response) => {
          var code = response.data.code;
          var data = response.data.data;

          if (code === '200') {
            this.$message.success(data);
            this.Return();
          } else {
            this.$message.warning('请求失败！请稍后重试');
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error('服务器未响应！请稍后重试');
        });
          }
      });
    },
    //查询
    async Find() {
      var url = 'template/selectAll';
      var record = {
        page_num: this.page_num,
        page_size: this.page_size,
        data_grouping: 'HtmbGl',
        template_name: this.ruleForm.template_name,
        dictionaries_name: this.ruleForm.dictionaries_name,
        start_date: this.ruleForm.start_date,
        end_date: this.ruleForm.end_date,
        template_content: this.ruleForm.template_content,
        template_url: this.ruleForm.template_url,
        template_state: this.ruleForm.template_state,
        reviewer_name: this.ruleForm.reviewer_name,
        reviewer_date: this.ruleForm.reviewer_date,
        reject_reason: this.ruleForm.reject_reason,
        dictionaries_name: this.ruleForm.dictionaries_name,
        start_date: this.ruleForm.start_date,
        end_date: this.ruleForm.end_date,
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.tableData = data.list;
          this.total = data.total;
        } else {
          this.$message.warning('请求失败！请稍后重试');
        }
      }
    },

    onEditorReady(editor) {
      // 准备编辑器
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    // 转码
    escapeStringHTML(str) {
      str = str.replace(/&lt;/g, '<');
      str = str.replace(/&gt;/g, '>');
      return str;
    },
  },
  async created() {
    this.Find();
    var staffList = await this.$globals.AxiosPost('dictionaries/selectFind', {
      data_grouping: 'contract_type',
    });
    this.staffList = staffList.data;
    // console.log(this.staffList);

    this.ruleForm = this.$parent.ruleForm;
  },
};
</script>

<style scoped>
/deep/ .ql-editor {
  height: 610px !important;
}
/deep/ .ql-toolbar.ql-snow {
  background-color: #ccc;
  display: block !important;
}
</style>


// WEBPACK FOOTER //
// HtmbGl_edit.vue?0cad427f